import * as React from 'react';
import * as styles from './HeadlinePage.scss';

type Props = Pick<React.HTMLAttributes<any>, 'children'>;

const HeadlinePage: React.SFC<Props> = props => {
    return <h1 className={styles.HeadlinePage}>{props.children}</h1>;
};

export default HeadlinePage;
